//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start

import { memo, useMemo, useState, useEffect, useRef, useCallback } from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { BzMasterAgGrid, BzTabs, BzTab, BzChip, BzDropdown, BzSearchableDropdown, BzButton } from "../../../components";
import { ALL_INDICES_SECTORS, CONTRACT_TYPES, DASHBOARD_EXPLORE_CATEGORY, DASHBOARD_MENUS, EXPIRY_TYPES, LIVE_PULSE_TABS, MULTIPLIER, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import { useSelector, useDispatch } from "react-redux";
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { getIndexSectorList } from "../../../redux/actions/screeners";
import { LIVE_PULSE_GRID_REF, convertScripResponseWatchlistGrid, convertToDate, createNewWatchlist, displayZeroStateForGrid, generateUniqueName, getExchangeName, gridDateFilter, isGuestUser, openOrderEntryModal, openOverviewModal, setLivePulseGridRef, updateDontmissToArrRowData, getMktSegIdFromMappedMktSegId } from "../../../utils/global_functions";
import moment from "moment";
import config from '../../../config.json';
import GridHeaderSearch from "../../GridHeaderSearch";
import { WatchlistGridPopover } from "../../Watchlist";
const { TenantId } = config;


const LivePulseGrid = ({ setNActiveCategory, setActiveNav, modifiedData, livePulseTab, setLivePulseTab, setExchangeState, exchangeState, indexSector, setIndicesSector }) => {

    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const groupedDontMissData = useSelector(state => state?.dontMiss?.groupedDontMissData);

    const { watchlists, globalWatchlists } = useSelector(state => state?.watchList);

    setLivePulseGridRef(useRef());
    let strSearch = null;
    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        LIVE_PULSE_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(LIVE_PULSE_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);
    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.companyName;
                return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
            }
        }, [strSearch]);


    const arrLivePulse = useSelector(state => state?.livePulse);
    const dispatch = useDispatch();

    const modalInfo = useSelector(state => state.modals?.modalData);
    const arrIndexSectorList = useSelector(state => state.screeners?.arrIndexSectorList);

    useEffect(() => {
        if (modalInfo?.nMappedCashinfo) {
            setLivePulseTab(modalInfo?.nMappedCashinfo);
            setIndicesSector(ALL_INDICES_SECTORS);
        }

    }, [modalInfo?.nMappedCashinfo]);

    useEffect(() => {
        if (arrIndexSectorList?.length < 1) {
            dispatch(getIndexSectorList());
        }
        setTimeout(() => {
            LIVE_PULSE_GRID_REF?.current?.api?.sizeColumnsToFit();
        }, 10);

    }, [dispatch]);



    const [arrLivePulseRowData, setArrLivePulseRowData] = useState(arrLivePulse?.arrLivePulse);
    const [strContractType, setStrContractType] = useState(CONTRACT_TYPES.ALL);
    const [expiryType, setExpiryType] = useState(EXPIRY_TYPES.NEAR);  // Vinit Raut : 13-02-2024 : BT-108797 -  Breeze - Live pulse expanded view 
    const LtpChange = ({ arrRowData }) => {
        const number = (arrRowData?.price * arrRowData?.nPercChange) / MULTIPLIER?.HUNDRED;
        const nLtpChange = parseFloat(number)?.toFixed(arrRowData?.decimalLocatorLength);
        return <div className={`font-regular font-size4 color-text ms-2 ${nLtpChange < 0 ? 'color-negative' : 'color-positive'}`} >{nLtpChange >= 0 ? `+${nLtpChange}` : nLtpChange}</div>;
    };

    // Vinit Raut : 13-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
    const PercentageChange = ({ arrRowData }) => {
        const percentage = arrRowData?.nPercChange;
        return <div className={`font-regular font-size4 color-text ms-2 ${percentage < 0 ? 'color-negative' : 'color-positive'}`} >{percentage >= 0 ? `+${percentage}` : percentage}%</div>;
    };
    // Vinit Raut : 13-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    // Vinit Raut : 15-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
    const LivePulseSymbolName = ({ arrRowData }) => {
        if ((arrRowData?.expiry && arrRowData?.nStrikePrice && arrRowData?.instrument?.trim())) {
            return (<div className='font-regular font-size4 color-subtext'>
                {`${arrRowData.expiry} ${parseFloat(arrRowData?.nStrikePrice) > 0 ? arrRowData?.nStrikePrice : ''} ${(arrRowData?.sOptionType === 'XX') ? '' : arrRowData?.sOptionType}`}
            </div>);
        } else if (!arrRowData?.expiry && !arrRowData?.nStrikePrice && !arrRowData?.sOptionType) {
            return (<div className='d-flex align-items-center'><div className='font-regular font-size4 color-subtext'>{arrRowData?.sSeries}</div></div>);
        } else if (arrRowData?.expiry && !arrRowData?.nStrikePrice) {
            return (<div className='font-regular font-size4 color-subtext'>{`${arrRowData?.expiry} ${arrRowData?.sInstrumentName.slice(0, 3)}`}</div>);
        } else {
            return null;
        }
    };

    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    // Vinit Raut : 15-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    const LivePulseSymbol = ({ arrRowData }) => {
        return (
            <div className='d-flex justify-content-start align-items-center'>
                <div className='font-medium font-size4 color-text text-uppercase ms-2 me-2'>{arrRowData.companyName}</div>
                <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{exchangeState}</BzChip>
                </div>
                <LivePulseSymbolName arrRowData={arrRowData} />
            </div>
        );
    };

    const fieldToNotShowSign = [
        "nVolume",
        "LTP",
        "nOpenInterest",
        "nLTP",
        "CurrPrice",
        "latbv",
        "nResistance",
        "nSupport",
        "nClose",
        "Premium",
        "Discount",
        "nHigh",
        "nLow",
        "nClosePrice"
    ];

    const numFormmater = (value, field) => {
        let valueFomatted = 0;
        if (fieldToNotShowSign?.includes(field)) {
            valueFomatted = value !== undefined ? value ? !`${value}`.includes('-') ? `${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        } else if (field === "FAOPercChange") {
            valueFomatted = value !== undefined ? parseFloat(value)?.toFixed(2) ? !`${parseFloat(value)?.toFixed(2)}`.includes('-') ? `+${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        } else if (field === "Circuit") {
            valueFomatted = value;
        }
        else {
            valueFomatted = value;
            // valueFomatted = value !== undefined && value != 0 ? value ? !`${value}`.includes('-') ? `+${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        }
        return valueFomatted;
    };


    const handleRender = ({ data: arrRowData, value, colDef, ...props }, placement) => {
        let convertedData = [];
        if (arrRowData) {
            arrRowData['MktSegId'] = getMktSegIdFromMappedMktSegId(Number(arrRowData.nMarketSegmentId));
            arrRowData['sSymbol'] = arrRowData?.companyName;
            arrRowData['nToken'] = Number(arrRowData?.nToken);
            arrRowData['sSeries'] = arrRowData?.sSeries;
            arrRowData['sExchange'] = getExchangeName(getMktSegIdFromMappedMktSegId(parseFloat(arrRowData['MktSegId'])));
            arrRowData['nLTP'] = arrRowData?.price;
            arrRowData['nPercChange'] = arrRowData?.nPercChange ? parseFloat(arrRowData?.nPercChange)?.toFixed(2) : parseFloat(arrRowData?.nPercChange || 0)?.toFixed(2);
            arrRowData['nPriceTick'] = 0.00;
            arrRowData['DecimalLocator'] = 2;
            if (arrRowData?.strExchangeSegment?.split("_")[1] !== "EQ") {
                arrRowData['nExpiryDate1'] = arrRowData?.nExpiryDate ? convertToDate(arrRowData?.nExpiryDate, "DDMMMYYYY").toUpperCase() : arrRowData?.nExpiryDate1 ? convertToDate(arrRowData?.nExpiryDate1, "DDMMMYYYY").toUpperCase() : undefined;
                arrRowData['nStrikePrice1'] = arrRowData?.nStrikePrice != -0.01 && arrRowData?.nStrikePrice != 0.00 && arrRowData?.nStrikePrice != 0.0000 ? arrRowData?.nStrikePrice : '';
                arrRowData['sOptionType'] = arrRowData?.sOptionType || '';
            }
            // if (colDef?.field === "Circuit") {
            //     value = `${arrRowData['nLowPriceRange']}-${arrRowData['nHighPriceRange']}`;
            // }
            // if (colDef?.field === "price") {
            //     value = `${arrRowData['nLTP'] - arrRowData['nClose']}`;
            // }
            convertedData = updateDontmissToArrRowData(groupedDontMissData, convertScripResponseWatchlistGrid([arrRowData], true));
        } else {
            convertedData = [];
        }
        return (
            (convertedData?.length) ?
                <WatchlistGridPopover isAddtoWatchlist={true} placement={placement} arrRowData={convertedData[0]} pageCalled={true} {...props} >
                    {colDef?.field === "nPercChange" ? <PercentageChange arrRowData={arrRowData} />
                        : colDef?.field === "nLtpChange" ? <LtpChange arrRowData={arrRowData} />
                            : colDef?.field === "sSupport" ? <div className='chips-wrap d-flex justify-content-center py-2' > <BzChip className={`chips  ${arrRowData.ltpClass === 'color-negative' ? 'negative-chip' : arrRowData?.ltpClass === 'color-positive' ? 'positive-chip' : 'default-chip'}`}>{arrRowData?.sSupport}</BzChip></div>
                                : colDef?.field === "sSymbol" ? <>  <LivePulseSymbol arrRowData={arrRowData} value={value} />{
                                    convertedData[0][WATCHLIST_GRID_INDEX.DONT_MISS] !== "0" && convertedData[0][WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                                    <div className='normal-scrip dontmiss-scrip'></div>
                                }
                                </> : numFormmater(value, colDef?.field)}
                </WatchlistGridPopover> : null
        );
    };

    useEffect(() => {
        setTimeout(() => {
            let firstRowNode = LIVE_PULSE_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
            if (firstRowNode) {
                firstRowNode.setSelected(true);
            }
        }, 100);

    }, [arrLivePulseRowData]);


    const arrLivePulseColumnDefs = useMemo(() => [
        {
            field: "sSymbol",
            headerComponent: GridHeaderSearch,
            headerComponentParams: { onChangeGridHeaderSearch, gridRef: LIVE_PULSE_GRID_REF },
            cellRenderer: (props) => handleRender(props, 'left'),
            // cellRenderer: LivePulseSymbol,
            // cellRendererParams: {
            //     placement: 'right',
            //     exchangeState
            // },
            width: 325,
            pinned: 'left',
            suppressMovable: true,
            lockPosition: "left",
            suppressNavigable: true, // Vinit Raut : 13-12-2023 : BT-108797 -  Breeze - Live pulse expanded view 
            headerClass: 'column-scripname-header'
        },
        // Vinit Raut : 19-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
        {
            field: 'price', headerName: "LTP", filter: 'agTextColumnFilter', cellStyle: { textAlign: 'center' },
            cellRenderer: (props) => handleRender(props, 'left'),
            filterParams: {
                textMatcher: ({ filterOption, value, filterText }) => {
                    if (filterText == null) {
                        return false;
                    } else {
                        switch (filterOption) {
                            case 'equals': {
                                return parseFloat(filterText) === parseFloat(value);
                            }
                            case 'notEqual': {
                                return parseFloat(filterText) !== parseFloat(value);
                            }
                            case 'lessThan': {
                                return parseFloat(value) < parseFloat(filterText);
                            }
                            case 'lessThanOrEqual': {
                                return parseFloat(value) <= parseFloat(filterText);
                            }
                            case 'greaterThan': {
                                return parseFloat(value) > parseFloat(filterText);
                            }
                            case 'greaterThanOrEqual': {
                                return parseFloat(value) >= parseFloat(filterText);
                            }
                            case 'inRange': {
                                const agFilterModel = LIVE_PULSE_GRID_REF?.current?.api?.getFilterModel()['price'];
                                if (Object?.keys(agFilterModel)?.length > 0) {
                                    const fromValue = agFilterModel?.filter;
                                    const toValue = agFilterModel?.filterTo;
                                    return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                                } else {
                                    return false;
                                }
                            }
                            case 'blank': {
                                return false;
                            }
                            case 'notBlank': {
                                return true;
                            }
                            default:
                                return false;
                        }
                    }
                },
                filterOptions: [
                    'equals',
                    'notEqual',
                    'lessThan',
                    'lessThanOrEqual',
                    'greaterThan',
                    'greaterThanOrEqual',
                    'inRange',
                    'blank',
                    'notBlank'
                ]
            }, comparator: sortingComparator
        },
        // Vinit Raut : 19-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
        {
            field: 'nLtpChange', headerName: "CHANGE", filter: 'agTextColumnFilter',
            cellRenderer: (props) => handleRender(props, 'left'),
            // cellRenderer: ltpChange,
            filterParams: {
                textMatcher: ({ filterOption, value, filterText }) => {
                    if (filterText == null) {
                        return false;
                    } else {
                        switch (filterOption) {
                            case 'equals': {
                                return parseFloat(filterText) === parseFloat(value);
                            }
                            case 'notEqual': {
                                return parseFloat(filterText) !== parseFloat(value);
                            }
                            case 'lessThan': {
                                return parseFloat(value) < parseFloat(filterText);
                            }
                            case 'lessThanOrEqual': {
                                return parseFloat(value) <= parseFloat(filterText);
                            }
                            case 'greaterThan': {
                                return parseFloat(value) > parseFloat(filterText);
                            }
                            case 'greaterThanOrEqual': {
                                return parseFloat(value) >= parseFloat(filterText);
                            }
                            case 'inRange': {
                                const agFilterModel = LIVE_PULSE_GRID_REF?.current?.api?.getFilterModel()['nLtpChange'];
                                if (Object?.keys(agFilterModel)?.length > 0) {
                                    const fromValue = agFilterModel?.filter;
                                    const toValue = agFilterModel?.filterTo;
                                    return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                                } else {
                                    return false;
                                }
                            }
                            case 'blank': {
                                return false;
                            }
                            case 'notBlank': {
                                return true;
                            }
                            default:
                                return false;
                        }
                    }
                },
                filterOptions: [
                    'equals',
                    'notEqual',
                    'lessThan',
                    'lessThanOrEqual',
                    'greaterThan',
                    'greaterThanOrEqual',
                    'inRange',
                    'blank',
                    'notBlank'
                ]
            }, comparator: sortingComparator
        },
        {
            field: 'nPercChange', headerName: "% CHANGE", filter: 'agTextColumnFilter',
            cellRenderer: (props) => handleRender(props, 'left'),
            //  cellRenderer: percentageChange,
            filterParams: {
                textMatcher: ({ filterOption, value, filterText }) => {
                    if (filterText == null) {
                        return false;
                    } else {
                        switch (filterOption) {
                            case 'equals': {
                                return parseFloat(filterText) === parseFloat(value);
                            }
                            case 'notEqual': {
                                return parseFloat(filterText) !== parseFloat(value);
                            }
                            case 'lessThan': {
                                return parseFloat(value) < parseFloat(filterText);
                            }
                            case 'lessThanOrEqual': {
                                return parseFloat(value) <= parseFloat(filterText);
                            }
                            case 'greaterThan': {
                                return parseFloat(value) > parseFloat(filterText);
                            }
                            case 'greaterThanOrEqual': {
                                return parseFloat(value) >= parseFloat(filterText);
                            }
                            case 'inRange': {
                                const agFilterModel = LIVE_PULSE_GRID_REF?.current?.api?.getFilterModel()['nPercChange'];
                                if (Object?.keys(agFilterModel)?.length > 0) {
                                    const fromValue = agFilterModel?.filter;
                                    const toValue = agFilterModel?.filterTo;
                                    return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                                } else {
                                    return false;
                                }
                            }
                            case 'blank': {
                                return false;
                            }
                            case 'notBlank': {
                                return true;
                            }
                            default:
                                return false;
                        }
                    }
                },
                filterOptions: [
                    'equals',
                    'notEqual',
                    'lessThan',
                    'lessThanOrEqual',
                    'greaterThan',
                    'greaterThanOrEqual',
                    'inRange',
                    'blank',
                    'notBlank'
                ]
            }, comparator: sortingComparator
        },
        // Vinit Raut : 15-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
        {
            field: 'sSupport', headerName: "REASON", filter: 'agMultiColumnFilter',
            //  cellRenderer: reasonData 
            cellRenderer: (props) => handleRender(props, 'left')
        },
        {
            field: 'date', headerName: "DATE", filter: 'agDateColumnFilter', cellRenderer: (props) => handleRender(props, 'left'), filterParams: {
                comparator: gridDateFilter
            },
        },
        { field: "time", headerName: "Time", filter: 'agTimeColumnFilter', cellRenderer: (props) => handleRender(props, 'left')},

    ], [exchangeState]);
    // Vinit Raut : 29-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    const handleIndexChange = (e) => {
        setIndicesSector(e);
        setStrContractType(CONTRACT_TYPES.ALL);
        setExpiryType(EXPIRY_TYPES.NEAR);  // Vinit Raut  13-02-2024 : BT-108797 -  Breeze - Live pulse expanded view 
    };

    // SumitG and Vinit Raut -05-12-23 
    const handleExchangeChange = (exchangeName) => {
        setStrContractType(CONTRACT_TYPES.ALL);
        setExpiryType(EXPIRY_TYPES.NEAR); // Vinit Raut  13-02-2024 : BT-108797 -  Breeze - Live pulse expanded view 
        setExchangeState(exchangeName);
    };

    const handleExpandCollapse = () => {
        setActiveNav(DASHBOARD_MENUS.LIVE_PULSE);
        setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.MAIN);
        dispatch(handleModalData({ nMappedCashinfo: livePulseTab, nMappedExchange: exchangeState }));  // Vinit Raut - 19/02/2024  - BT-107438 Breeze - Dashboard - Live Pulse 
    };

    // SumitG and Vinit Raut -05-12-23 
    // Vinit Raut : 29-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
    const handleContractChange = (contractName) => {
        setStrContractType(contractName);
        setExpiryType(EXPIRY_TYPES.NEAR);
    };

    // SumitG and Vinit Raut -05-12-23 
    const handleExpiryChange = (expiryValue) => {
        setExpiryType(expiryValue);
    };
    // Vinit Raut : 29-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    useEffect(() => {
        if (livePulseTab?.name === LIVE_PULSE_TABS.EQUITY) {
            if (arrLivePulse?.arrLivePulse?.length > 0) {
                setArrLivePulseRowData(arrLivePulse?.arrLivePulse);
            } else {
                setArrLivePulseRowData([]);
            }
        } else if (strContractType === CONTRACT_TYPES.ALL) {
            const filteredData = arrLivePulse?.arrLivePulse?.filter((item) => item?.expiryMonth === expiryType);
            if (filteredData?.length > 0) {
                setArrLivePulseRowData(filteredData);
            } else {
                setArrLivePulseRowData([]);

            }
        } else if (strContractType === CONTRACT_TYPES.FUTURES) {
            const filteredData = arrLivePulse?.arrLivePulse?.filter((item) => {
                if (livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY) {
                    return item?.sOptionType !== 'CE' && item?.sOptionType !== 'PE' && item?.instrument?.includes("FU") && item?.expiryMonth === expiryType;
                } else {
                    return item?.sOptionType !== 'CE' && item?.sOptionType !== 'PE' && item?.instrument?.includes("FU");
                }
            });
            if (filteredData?.length > 0) {
                setArrLivePulseRowData(filteredData);
            } else {
                setArrLivePulseRowData([]);
            }
        } else if (strContractType === CONTRACT_TYPES.CALL_PUT_OPTIONS) {
            const filteredData = arrLivePulse?.arrLivePulse?.filter((item) => {
                if (livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY) {
                    return item?.instrument?.includes("OP") && (item?.sOptionType === 'CE' || item?.sOptionType === 'PE') && +item?.nStrikePrice > 0 && item?.expiryMonth === expiryType;
                } else {
                    return item?.instrument?.includes("OP") && (item?.sOptionType === 'CE' || item?.sOptionType === 'PE') && +item?.nStrikePrice > 0;
                }
            });
            if (filteredData?.length > 0) {
                setArrLivePulseRowData(filteredData);
            } else {
                setArrLivePulseRowData([]);
            }
        } else if (strContractType === CONTRACT_TYPES.CALL_OPTIONS) {
            const filteredData = arrLivePulse?.arrLivePulse?.filter((item) => {
                if (livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY) {
                    return item?.instrument?.includes("OP") && item?.sOptionType === 'CE' && +item?.nStrikePrice > 0 && item?.expiryMonth === expiryType;
                } else {
                    return item?.instrument?.includes("OP") && item?.sOptionType === 'CE' && +item?.nStrikePrice > 0;
                }
            });
            if (filteredData?.length > 0) {
                setArrLivePulseRowData(filteredData);
            } else {
                setArrLivePulseRowData([]);
            }
        } else if (strContractType === CONTRACT_TYPES.PUT_OPTIONS) {
            const filteredByPutType = arrLivePulse?.arrLivePulse?.filter((item) => {
                if (livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY) {
                    return item?.instrument?.includes("OP") && item?.sOptionType === 'PE' && +item?.nStrikePrice > 0 && item?.expiryMonth === expiryType;
                } else {
                    return item?.instrument?.includes("OP") && item?.sOptionType === 'PE' && +item?.nStrikePrice > 0;
                }
            });
            if (filteredByPutType?.length > 0) {
                setArrLivePulseRowData(filteredByPutType);
            } else {
                setArrLivePulseRowData([]);
            }
        }
    }, [strContractType, expiryType, arrLivePulse, livePulseTab, exchangeState, indexSector]);
    // Vinit Raut : 13-02-2024 : BT-108797 - Breeze - Live pulse expanded view -- End

    const handleLivePulseTabChange = (data) => {
        setExchangeState(data.exchanges[0].exchName);
        setLivePulseTab(data);
        setIndicesSector(ALL_INDICES_SECTORS);
        setStrContractType(CONTRACT_TYPES.ALL);   // Vinit Raut : 29-11-2023 : BT-108797 -  Breeze - Live pulse expanded view 
        setExpiryType(EXPIRY_TYPES.NEAR); // Vinit Raut  13-02-2024 : BT-108797 -  Breeze - Live pulse expanded view 
        // LIVE_PULSE_GRID_REF.current.api.getColumnDefs()?.forEach((node) =>
        //     LIVE_PULSE_GRID_REF.current.api?.setFilterModel(node.colId, null)
        // ); // Vinit Raut : 18-12-2023 : BT-108797 -  Breeze - Live pulse expanded view 
    };

    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    const handleCreateWatchlist = () => {
        const arrScrips = arrLivePulseRowData?.map((eachScrip) => {
            return { nMarketSegmentId: eachScrip?.nMarketSegmentId, nToken: eachScrip?.nToken };
        });
        let wathlistToSearch = "Live Pulse";
        const suffixName = generateUniqueName(wathlistToSearch, globalWatchlists, watchlists);
        createNewWatchlist(objLoginSession, arrScrips, "static", TenantId, suffixName, "Live Pulse", dispatch);
    };
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end

    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- Start 

    const isOpen = useSelector(state => state?.addendumreducer?.isOpen);
    const modals = useSelector(state => state.modals.modals);

    const bISGridShortCutsAllow = useMemo(() => {

        return !Object.keys(modals)?.some((eachModal) => modals[eachModal]) && !isOpen; //isOpen is state of addendum modal

    }, [modals, isOpen]);

    const handleBuySell = (buySell) => {
        if (!isGuestUser()) {
            if (LIVE_PULSE_GRID_REF?.current?.api.getSelectedRows().length > 0 && bISGridShortCutsAllow) {
                const objRowData = LIVE_PULSE_GRID_REF?.current?.api?.getSelectedRows()[0];
                if (objRowData) {
                    openOrderEntryModal(null, null, objLoginSession, objRowData?.MktSegId, objRowData?.nToken, buySell);
                } else { }
            } else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }


    };

    const handleOverview = (e) => {
        e.preventDefault(); // Prevent the default browser behavior for F5 key press
        if (LIVE_PULSE_GRID_REF?.current?.api.getSelectedRows().length > 0 && bISGridShortCutsAllow) {
            const [arrSelectedRowScripData] = convertScripResponseWatchlistGrid([LIVE_PULSE_GRID_REF?.current?.api?.getSelectedRows()[0]]);
            if (arrSelectedRowScripData?.length > 0) {
                openOverviewModal(true, arrSelectedRowScripData, false, false, dispatch, {});
            }
        }
        else { }

    };

    // useSingleKey('f1', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    // });
    // useSingleKey('f2', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    // });



    // useSingleKey('f5', handleOverview);

    // useSingleKey('enter', (e) => {
    //     if (bISGridShortCutsAllow) {
    //         handleOverview(e);
    //     }
    // });
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- End 
    const handleKeyEvents = useCallback((e) => {
        let key = e?.key?.toLowerCase();
        switch (key) {


            case 'f1':

                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                break;

            case 'f2':

                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                break;

            case 'f5':
                handleOverview(e);
                break;

            case 'enter':
                if (bISGridShortCutsAllow) {
                    handleOverview(e);
                }
                break;

            default: break;

        }
    }, [bISGridShortCutsAllow]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents);
        return () => {
            document.removeEventListener('keydown', handleKeyEvents);
        };
    }, [handleKeyEvents]);

    return (
        // SumitG and Vinit Raut -05-12-23    
        <Container fluid className='g-0 mb-2 px-3 livepulse-dashboard-expand-wrapper'>
            <Row className='g-0 py-2 bdr-btm justify-content-center align-items-center gap-2'>
                <Col data-testid="livepulse-heading" md="auto"  className='d-flex justify-content-start align-items-center gap-2'>
                    <div className='icon-24 icon-live-pulse'></div>
                    <div className='font-medium font-size5 color-text text-uppercase'>Live Pulse</div>
                </Col>
                <Col md={8} className='p-0 justify-content-center flex-grow-1'>
                    <div className='horizontal-scroll-wrap d-flex justify-content-center text-center'>
                        <BzTabs className='nav nav-tabs'>
                            {modifiedData?.length > 0 && modifiedData?.map(data => {
                                return <BzTab data-testid={`livepulse-${data?.name}-tab`} className='nav-link text-capitalize' tabKey={data.id.toString()} isActive={livePulseTab.id === data.id} onClick={handleLivePulseTabChange.bind(this, data)}>{data.name}</BzTab>;
                            })}
                        </BzTabs>
                    </div>
                </Col>
                <Col md='auto' className='d-flex justify-content-end align-items-center'>
                    <div data-testid="livepulse-collapse-icon" className='background-icon' onClick={handleExpandCollapse}>
                        <div className='icon-16 icon-collapse icon-dark'></div>
                    </div>
                </Col>
            </Row>
            <Row className='g-0 mt-4 mb-3 align-items-center'>
                <Col className='d-flex justify-content-start align-items-center'>
                    <div className='screen-dropdown'>
                        <BzDropdown>
                            <Dropdown.Toggle data-testid='livepulse-exch-dropdown-toggle' className='btn-primary'>{exchangeState}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {modifiedData?.length > 0 && modifiedData[modifiedData?.findIndex(md => md.id === livePulseTab.id)]?.exchanges?.map((data) => <Dropdown.Item data-testid={`livepulse-exchange-dropdown-${data?.exchName}-item`} key={data.exchName} onClick={() => handleExchangeChange(data.exchName)}>{data.exchName}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>

                    {(livePulseTab?.name === LIVE_PULSE_TABS.EQUITY) ?
                        <div className='d-flex align-items-center ms-3'>
                            <div className='font-regular font-size3 color-text p-t-3'>Indices/Sector:</div>
                            <div data-testid='livepulse-indices-sector-dropdown-toggle' className='screen-fixeddropdown ms-2'>
                                <BzSearchableDropdown strToggelValue={indexSector === 'All' ? "ALL" : indexSector}>
                                    <Dropdown.Item data-testid={"livepulse-ind-sector-dropdown-All-item"} onClick={() => handleIndexChange("All")} value="ALL">ALL</Dropdown.Item>
                                    {arrIndexSectorList && arrIndexSectorList[exchangeState === 'NSE' ? 0 : exchangeState === 'BSE' ? 1 : null]?.map((item) => {
                                        return <Dropdown.Item data-testid={`livepulse-ind-sector-dropdown-${item.Name}-item`} onClick={handleIndexChange.bind(this, item.Name)} value={item.Name}>{item?.Name}</Dropdown.Item>
                                    })}
                                </BzSearchableDropdown>
                            </div>
                        </div>
                        : null}

                    {livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY ?
                        <div className='d-flex align-items-center ms-3'>
                            <div className='font-regular font-size3 color-text p-t-3'>Contract:</div>
                            <div className='screen-dropdown ms-2'>
                                <BzDropdown>
                                    <Dropdown.Toggle data-testid='livepulse-contract-dropdown-toggle' className='btn-default'>{strContractType}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item data-testid="livepulse-contract-dropdown-all-item" onClick={() => handleContractChange(CONTRACT_TYPES.ALL)}>{CONTRACT_TYPES.ALL}</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-contract-dropdown-futures-item" onClick={() => handleContractChange(CONTRACT_TYPES.FUTURES)}>{CONTRACT_TYPES.FUTURES}</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-contract-dropdown-call-put-options-item" onClick={() => handleContractChange(CONTRACT_TYPES.CALL_PUT_OPTIONS)}>{CONTRACT_TYPES.CALL_PUT_OPTIONS}</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-contract-dropdown-call-options-item" onClick={() => handleContractChange(CONTRACT_TYPES.CALL_OPTIONS)}>{CONTRACT_TYPES.CALL_OPTIONS}</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-contract-dropdown-put-options-item" onClick={() => handleContractChange(CONTRACT_TYPES.PUT_OPTIONS)}>{CONTRACT_TYPES.PUT_OPTIONS}</Dropdown.Item>
                                    </Dropdown.Menu>
                                </BzDropdown>
                            </div>
                        </div>
                        : null}

                    {livePulseTab?.name !== LIVE_PULSE_TABS.EQUITY ?
                        <div className='d-flex align-items-center ms-3'>
                            <div className='font-regular font-size3 color-text p-t-3'>Expiry:</div>
                            <div className='screen-dropdown ms-2'>
                                <BzDropdown>
                                    <Dropdown.Toggle data-testid="livepulse-expiry-dropdown-toggle" className='btn-default'>{expiryType === 1 ? "NEAR" : expiryType === 2 ? "NEXT" : "FAR"}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item data-testid="livepulse-expiry-dropdown-near-item" onClick={() => handleExpiryChange(EXPIRY_TYPES.NEAR)}>NEAR</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-expiry-dropdown-next-item"  onClick={() => handleExpiryChange(EXPIRY_TYPES.NEXT)}>NEXT</Dropdown.Item>
                                        <Dropdown.Item data-testid="livepulse-expiry-dropdown-far-item"  onClick={() => handleExpiryChange(EXPIRY_TYPES.FAR)}>FAR</Dropdown.Item>
                                    </Dropdown.Menu>
                                </BzDropdown>
                            </div>
                        </div>
                        : null}
                </Col>
                {arrLivePulseRowData?.length > 0 &&
                    <Col md='auto' className='d-flex justify-content-end align-items-center'>
                        <BzButton className='btn btn-sm btn-outline d-flex align-items-center ms-3' disabled={(arrLivePulseRowData?.length <= 0 || arrLivePulseRowData === undefined) ? true : false} onClick={handleCreateWatchlist}>
                            <div className='icon-12 icon-add icon-primary me-2'></div>
                            <span className='font-size2'>Watchlist</span>
                        </BzButton>
                    </Col>
                }
            </Row>
            <Row className='g-0'>
                <Col data-testid='livepulse-grid'>
                    <BzMasterAgGrid
                        isCompress={true} rowHeight={36}
                        arrRowData={arrLivePulseRowData}
                        arrColumnData={arrLivePulseColumnDefs}
                        className='ag-theme-alpine livepulse-ag-grid-wrapper'
                        ref={LIVE_PULSE_GRID_REF}
                        doesExternalFilterPass={doesExternalFilterPass}
                        isExternalFilterPresent={isExternalFilterPresent}
                    />
                </Col>
            </Row>
        </Container>

    );
};

export default memo(LivePulseGrid);
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End